import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TokenService {

  private _token: string = null;
  set token(token: string) {
      this._token = token;
      localStorage.setItem('access_token', token);
  }
  get token(): string {
      if(!this._token) this._token = localStorage.getItem('access_token');
      return this._token;
  }

  private _tokenExpiration: number = null;
  set tokenExpiration(unix: number) {
      this._tokenExpiration = unix;
      localStorage.setItem('token_expiration', unix.toString());
  }
  get tokenExpiration(): number {
      if(typeof this._tokenExpiration !== 'number'){
        let val = localStorage.getItem('token_expiration');
        if(typeof val === 'string') this._tokenExpiration = parseInt(val);
      }
      return this._tokenExpiration;
  }

  constructor() { }

  destroyLocalSession(){
    this._token = null;
    localStorage.removeItem("token_expiration");
    localStorage.removeItem("access_token");
  }
}
